import * as Jimp from 'jimp';


export const convertImageToAscii = async (): Promise<string> => {
    try {
        const imagePath = '/images/Baudin.jpg';
        const image = await Jimp.Jimp.read(imagePath);
        image.resize({ w: 30, h: 55 }).greyscale();

        const asciiCharacters = "%#*+=-:. ";
        let asciiArt = "";

        for (let y = 0; y < image.bitmap.height; y++) {
            for (let x = 0; x < image.bitmap.width; x++) {
                const pixelColor = image.getPixelColor(x, y);
                const { r } = Jimp.intToRGBA(pixelColor);
                const charIndex = Math.floor((r / 255) * (asciiCharacters.length - 1));
                asciiArt += asciiCharacters[charIndex];
            }
            asciiArt += "\n";
        }

        return asciiArt;
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(`Failed to process image: ${error.message}`);
        } else {
            throw new Error('Failed to process image: Unknown error');
        }
    }
};
